const log = () => {}

export default {
  // TODO: Move to getters?

  /* getMetaListWithAccessRights - Get all kanban lanes / commitments with access rights
   *
   * Usage:
   * this.$models.commitment.with({ goalId }).getListWithAccessRights()
   *
   */
  getMetaListWithAccessRights({ $store, $models }) { // = commitment_list_all?

    if ( !( 'goalId' in $store.definedProps ) ) {
      throw new Error('Please define goalId in "with".')
    }

    const goalId = $store.definedProps.goalId
    const access_tab = $models.goalMemberPrivacySettings.with({ goalId }).getAccessTab()

    // TODO: Team backlogs

    const commitments = $models.commitmentMeta.with({ goalId }).getList();

    for ( var commitmentId in commitments.items ) {
      let assigend_user = commitments.items[ commitmentId ].assignedUserId

      if ( assigend_user === 'TEAM' ) {
        console.warn('TODO');
      }

      commitments.items.access = access_tab[ assigend_user ] ||
        $models.goalMemberPrivacySettings.grantFullAccessEntry();

      // let commitment = $models.commitment.with({ goalId }).subscribeNode( commitmentId )
      // commitment.meta = commitment_meta;
    }

    return commitments;
  },

  /* getNodeFull - Get all kanban lanes / commitments with access rights
   *               Will automatically detect the correct user
   *
   * Usage:
   * this.$models.commitment.with({ goalId }).getNodeFull()
   *
   */
  getNodeFull({ $store, $models }, commitmentId ) {
    // Syntax: action({ $store, $models, $registry })

    // Syntax: this.$models.commitment.with({ goalId: 999 }).getNodeFull( 123 )
    if ( !( 'goalId' in $store.definedProps ) ) {
      throw new Error('Please define goalId in "with".')
    }

    let goalId = $store.definedProps.goalId;

    log("[getNodeFull]: goalId", goalId, "commitmentId", commitmentId);

    let commitment_meta = $models.commitmentMeta.with({ goalId }).getNode( commitmentId )

    const access_tab = $models.goalMemberPrivacySettings.with({ goalId }).getAccessTab()

    if ( !commitment_meta.assignedUserId ) {
      console.warn('DID NOT FIND A assignedUserId in commitment_meta. THIS WARNING CAN BE REMOVED IN THE FUTURE');
    }

    const memberId = commitment_meta.assignedUserId /*|| 'TEAM';*/

    if ( memberId === "TEAM" ) {
      /* This means we got a team lane, which has no user settings */
    }

    const commitment_access = access_tab[ memberId ] ||
      $models.goalMemberPrivacySettings.grantFullAccessEntry();

    if ( commitment_access.allow_to_see_commitment ) {
      // ...
    }

    let commitment = $models.commitment.with({ uid: memberId, goalId }).subscribeNode( commitmentId )

    // commitment.meta = clonedeep( commitment_meta.$state );
    commitment.meta = commitment_meta;
    commitment.access = commitment_access;

    // TODO: enhance write ?

    return commitment;
  }
}
